import type { ServiceDocument } from '@mimir/common/dto/ServiceDocumentDtos';
import { QuashableApiClient } from '@mimir/common/util/quashableHttp';
import { dynamicApiClient } from '../aws/api/http';
import { setGlobalApiClient, setGlobalServiceDocument } from './backendClient';

export function initializeGlobalBackendClient(
  serviceDoc: ServiceDocument,
) {
  setGlobalServiceDocument(serviceDoc);
  setGlobalApiClient(new QuashableApiClient(
    dynamicApiClient()
  ));
}
